/**
 * Component displaying overall confidence score and reasoning for an AI execution.
 */

import classNames from 'classnames'
import React from 'react'
import { Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { getConfidenceConfig } from './ai-block-activity-helpers'

interface IOverallConfidenceDisplayProps {
  confidence?: number
  reasoning?: string
  showConfidenceBar?: boolean
}

export const OverallConfidenceDisplay: React.FC<IOverallConfidenceDisplayProps> = ({ confidence, reasoning, showConfidenceBar = false }) => {
  if (confidence == null && !reasoning) {
    return null
  }

  const { color, shortLabel } = getConfidenceConfig(confidence)
  const hasScore = confidence != null

  return (
    <div className='c-aiBlockResults-overallConfidenceSection'>
      {hasScore && (
        <div className='c-aiBlockResults-confidenceRow'>
          <span className='c-aiBlockResults-confidenceLabel'>Overall Confidence:</span>
          {showConfidenceBar && (
            <div className='c-aiBlockResults-confidenceBar'>
              <div
                className={classNames(
                  'c-aiBlockResults-confidenceBar-fill',
                  `c-aiBlockResults-confidenceBar-fill--${color}`,
                )}
                style={{ width: `${confidence}%` }}
              />
            </div>
          )}
          <span
            className={classNames(
              'c-aiBlockResults-confidenceScore',
              `c-aiBlockResults-confidenceScore--${color}`,
            )}
            title={`${confidence}%`}
          >
            {shortLabel}
          </span>
        </div>
      )}
      {reasoning && (
        <div className='c-aiBlockResults-reasoningRow'>
          <span className='c-aiBlockResults-reasoningLabel'>
            <Icon icon={IconNames.LIGHTBULB} iconSize={12} />
            Reasoning:
          </span>
          <span className='c-aiBlockResults-reasoningText'>{reasoning}</span>
        </div>
      )}
    </div>
  )
}
